import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgCloudDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M24 10.663A5.82 5.82 0 0 0 22.228 6.5a5.7 5.7 0 0 0-3.447-1.585.25.25 0 0 1-.191-.12 7.684 7.684 0 0 0-14.1 2.294.25.25 0 0 1-.227.2A4.59 4.59 0 0 0 0 11.859a4.32 4.32 0 0 0 1.236 3.21 5.53 5.53 0 0 0 3.605 1.377 1 1 0 0 0 .985-1.015 1.023 1.023 0 0 0-1.015-.985 3.3 3.3 0 0 1-2.172-.8A2.37 2.37 0 0 1 2 11.859a2.58 2.58 0 0 1 .954-2.007 2.6 2.6 0 0 1 2.167-.527 1 1 0 0 0 1.2-.919 5.686 5.686 0 0 1 10.82-2.088.96.96 0 0 0 .941.57 3.69 3.69 0 0 1 2.758 1.049A3.75 3.75 0 0 1 22 10.663a3.835 3.835 0 0 1-3.438 3.791 1 1 0 0 0 .132 1.992 1 1 0 0 0 .131-.009A5.807 5.807 0 0 0 24 10.663"
      fill="currentColor"
    />
    <path
      d="M15.5 17.446h-1.75a.25.25 0 0 1-.25-.25v-7.25a1.5 1.5 0 1 0-3 0V17.2a.25.25 0 0 1-.25.25H8.5a1 1 0 0 0-.707 1.707l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0-.707-1.707Z"
      fill="currentColor"
    />
  </svg>
);
